export interface AuthResponse{
    status: AuthenticationResponse,
    token: string
}

export enum AuthenticationResponse {
    UsernameOrPasswordError,
    AccountLocked,
    Successful,
    SocialRegistration,
    UnexpectedError
}